// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "cherehapa-flight-delay." + {"159":"3f83fb7f7b36735defc9","636":"58126045ebda5927e858"}[chunkId] + ".js";
};